import React, { useEffect } from 'react'
import { FilterSection } from '../search/FiltersSidebar'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchServices } from '../../features/admin/serviceSlice';

const RoomFilter = ({ openFilter, setOpenFilter, filters, setFilters }: { openFilter: boolean, setOpenFilter: any, filters: any, setFilters: (val: any) => void }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>()
    const { services } = useSelector((state: RootState) => state.serviceSlice)
    useEffect(() => {
        dispatch(fetchServices())
    }, [dispatch])

    const handleFacilityChange = (value: string) => {
        const val = Number(value);
        const newServices = filters.services.includes(val)
            ? filters.services.filter((v: number) => v !== val)
            : [...filters.services, val];

        setFilters({ ...filters, services: newServices });
    };
    const handleTypeChange = (value: string) => {
        setFilters({ ...filters, rate: value });
    };
    const handlePriceChange = (value: string) => {
        let min = 0;
        let max = 0;
        if (value === '10000') {
            min = 10000;
            max = 1000000;
        } else {
            const parts = value.split("-");
            min = +parts[0];
            max = +parts[1];
        }
        setFilters({ ...filters, minPrice: min, maxPrice: max });
    };
    const resetFilters = () => {
        setFilters({
            minPrice: 0,
            maxPrice: 0,
            type: "",
            services: [],
        });
    };
    return (
        <div className={`md:col-span-1 md:block p-6 md:h-fit space-y-5 bg-white md:rounded-2xl shadow-md transition-all duration-300 ease-in-out ${openFilter ? 'xs:translate-x-0 xs:rounded-none xs:h-screen xs:overflow-y-auto xs:opacity-100 xs:fixed xs:z-[10001] xs:w-full xs:mt-0' : 'xs:-translate-x-full xs:opacity-0'} xs:top-0 xs:left-0 md:static md:opacity-100 md:translate-x-0 md:transform-none`}>
            {openFilter && (
                <button
                    onClick={() => setOpenFilter(false)}
                    className=" text-blue-500 text-xl md:hidden xs:block"
                >
                    ✕
                </button>
            )}

            <FilterSection
                title={t("room-type")}
                options={[
                    { label: t("all"), value: "" },
                    { label: t("Single"), value: "Single" },
                    { label: t("Delux"), value: "Delux" },
                    { label: t("Suite"), value: "Suite" },

                ]}
                selected={filters.type}
                onChange={handleTypeChange}
            />
            <FilterSection
                title={t("price")}
                options={[
                    { label: '10 - 100', value: '10-100' },
                    { label: '100 - 500', value: '100-500' },
                    { label: '500  - 2,500', value: '500-2500' },
                    { label: '2,500  - 10,000', value: '2500-10000' },
                    { label: '+10,000 ', value: '10000' },
                ]}
                selected={
                    (() => {
                        const { minPrice, maxPrice } = filters;
                        if (minPrice === 10000 && maxPrice === 1000000) return ['10000'];
                        if (minPrice === 10 && maxPrice === 100) return ['10-100'];
                        if (minPrice === 100 && maxPrice === 500) return ['100-500'];
                        if (minPrice === 500 && maxPrice === 2500) return ['500-2500'];
                        if (minPrice === 2500 && maxPrice === 10000) return ['2500-10000'];
                        return [];
                    })()
                }
                onChange={handlePriceChange}
            />
            {/* Services */}
            <FilterSection
                title={t("services")}
                options={services?.map((ser: any) => ({
                    label: ser.title,
                    value: ser.id.toString(),
                }))}
                selected={filters.services.map(String)}
                onChange={handleFacilityChange}
                showMoreCount={5}
            />

            {/* Reset Button */}
            <button onClick={() => resetFilters()} className="w-full flex items-center justify-center gap-2 mt-6 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:border-red-400 hover:text-red-600 hover:bg-red-50 transition-colors duration-200">
                {t("reset-filter")}
            </button>
        </div>
    )
}

export default RoomFilter